<i18n>
{
  "fr": {
    "specific": "Spécifique"

  },
  "en": {
    "specific": "Specific"
  }
}
</i18n>

<template>
  <span
    v-if="(isApplicable && statusBadge) || isSpecific"
    class="status-badge"
    :class="[statusBadge ? `has-text-${statusBadge.color}` : '', { 'has-text-turquoise': isSpecific }]"
    :title="badgeTitle"
  >
    <span
      v-if="count"
      class="status-badge__count has-text-weight-medium is-size-7 mr-8px"
      :class="[statusBadge ? `has-text-${statusBadge.color}` : '', { 'is-turquoise': isSpecific }]"
    >
      {{ count }}
    </span>
    <img v-if="isSpecific" class="status-badge__img" :src="require('@/assets/icon-specific.svg')" />
    <b-icon
      v-else-if="statusBadge"
      size="is-small"
      :type="`is-${statusBadge.color}`"
      :class="{ 'mr-4px': showLabel }"
      :pack="statusBadge.iconPack"
      :icon="statusBadge.icon"
    />
    <small v-if="showLabel">
      <span v-if="isSpecific">{{ $t('specific') }}</span>
      <span v-else-if="statusBadge">{{ statusBadge.label }}</span>
    </small>
  </span>
</template>

<script>
import IndicatorHelper from '@/helpers/indicator-helper'

export default {
  props: {
    badge: {
      type: Object,
      default: null
    },
    indicator: {
      type: Object,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    hideNotApplicable: {
      type: Boolean,
      default: false
    },
    count: Number,
    isSpecific: Boolean
  },
  computed: {
    isApplicable() {
      if (!this.hideNotApplicable || this.isSpecific) return true
      return IndicatorHelper.isApplicable(this.indicator)
    },
    statusBadge() {
      if (this.badge) return this.badge
      if (this.isSpecific) return null
      return IndicatorHelper.getStatusBadge(this.indicator)
    },
    badgeTitle() {
      if (this.statusBadge) return this.statusBadge.label
      if (this.isSpecific) return this.$t('specific')
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
$icon-height: 15px;

.status-badge {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;

  &__count {
    position: relative;
    top: -1px;
  }

  &__img {
    height: $icon-height;
  }
}
</style>
